export enum AddServiceContractPosTypeOfPos {
  DEFAULT = 'DEFAULT',
  HEADLINE = 'HEADLINE',
  TEXTLINE = 'TEXTLINE',
}
